import React from "react";
import { graphql, useFragment, useMutation } from "react-relay";
import { WorkspaceTodoEditMainExpireSelector_Todo$key } from "./__generated__/WorkspaceTodoEditMainExpireSelector_Todo.graphql";
import { WorkspaceTodoEditMainExpireSelectorSetPriorityMutation } from "./__generated__/WorkspaceTodoEditMainExpireSelectorSetPriorityMutation.graphql";
import { DateTime } from "luxon";

import { WebDateSelector } from "../../../../../components/mobile/WebDateSelector/WebDateSelector";
import { FormattedMessage } from "react-intl";
import { useWorkspaceTimeZone } from "../../../../../OS/WorkspaceTimezone";

export function ExpireSelector(props: {
  todo: WorkspaceTodoEditMainExpireSelector_Todo$key;
  disabled?: boolean;
}) {
  const data = useFragment(
    graphql`
      fragment WorkspaceTodoEditMainExpireSelector_Todo on TodoWorkspace {
        id

        updatedBy {
          id
          name
        }
        expireAtDate {
          isoString
        }

        updatedAtDate {
          ...FormattedDate
          isoString
        }
      }
    `,
    props.todo
  );

  const [setExpireAtMutation] =
    useMutation<WorkspaceTodoEditMainExpireSelectorSetPriorityMutation>(graphql`
      mutation WorkspaceTodoEditMainExpireSelectorSetPriorityMutation(
        $id: ID!
        $expireAt: String
      ) @raw_response_type {
        todoWorkspace(id: $id) {
          updateExpireAt(newExpireAt: $expireAt) {
            id
            expireAtDate {
              isoString
            }
            updatedAtDate {
              ...FormattedDate
              isoString
            }
            ...WorkspaceTodoEditMainExpireSelector_Todo
          }
        }
      }
    `);

  const date = data.expireAtDate
    ? DateTime.fromISO(data.expireAtDate.isoString)
    : null;

  const tz = useWorkspaceTimeZone();
  return (
    <WebDateSelector
      type="datetime"
      disabled={props.disabled}
      timezone={tz}
      placeholder={
        <FormattedMessage
          description="WorkspaceTodoEditMain Date Placeholder"
          defaultMessage="Add Deadline"
        />
      }
      minDate={DateTime.local()}
      value={date}
      onChangeValue={(val) => {
        const expireAt = val?.toISO() ?? null;
        setExpireAtMutation({
          optimisticResponse: {
            todoWorkspace: {
              updateExpireAt: {
                id: data.id,
                expireAtDate: val ? { isoString: val.toISO() ?? "" } : null,

                updatedAtDate: data.updatedAtDate
                  ? { ...data.updatedAtDate, __isDate: "UnzonedDate" }
                  : null,
                updatedBy: data.updatedBy,
              },
            },
          },
          variables: {
            id: data.id,
            expireAt,
          },
        });
      }}
    />
  );
}
